<template lang="html">

	<section class="column-setter" :style="ownstyle.contenedor">

		<p>{{$t('modifica_columnas')}}</p>

		<div class="contenedor-inputs">

			<template v-for="(n,key) in columns">
				<div class="contenedor-input" :style="styles.input_black">
					<input type="checkbox" :id="`columna-${key}`" v-model="n.visible" @change="$emit('change')">
					<label :for="`columna-${key}`">{{n.nombre}}</label>
				</div>
			</template>

		</div>

		<a class="btn" @click="$emit('cerrar')" :style="styles.solidPrimary">{{$t('guardar')}}</a>

	</section>

</template>

<script lang="js">
	
	import {mapGetters} from 'vuex';

	export default  {
		name: 'column-setter',
		props: ['columns'],
		computed: {
			...mapGetters({
				colors : 'basicColors',
				styles : 'getStyles'
			}),
			ownstyle : function(){
				return {
					contenedor :{
						border: `8px solid #F02B58`,
						color : this.colors.text_black,
						background : this.colors.white
					}    			
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.column-setter {
		position: absolute;
		right: 0;
		top: 60px;
		padding: 20px;
		background: white;
		display: inline-block;
		width: 300px;
		height: auto;
		max-height: 900px;
		text-transform: initial;
		z-index: 5;
	}

	.contenedor-inputs{
		display: inline-block;
		max-height:35vh;
		overflow: scroll;
		overflow-x: hidden;
	}

	p{
		text-align: left;
		font-weight: 600;
		margin-bottom: 20px;
		margin-top: 20px;
		font-size: 16px;
	}

	.contenedor-input{
		margin-bottom: 0;
		padding-bottom: 0;


		label{
			text-transform: capitalize;
			font-weight: 600;
			font-size: 12px;
			color: currentColor;
		}
	}

	.btn{
		margin-top: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/components/parts/column-setter.vue